/**
 * Copy fragments shared by more than one master-passphrase screen, and the
 * fixed unlock error strings.
 *
 * The unlock strings are constants rather than inline literals for one reason:
 * §6.3's no-oracle rule says each pane renders EXACTLY ONE string regardless of
 * why the attempt failed — wrong passphrase, wrong phrase, a corrupt wrap, no
 * vault at all. Two call sites with two literals drift; one constant cannot.
 * `unlockErrorsAreFixedStrings` in the tests pins that.
 */

/** §6.3 pane A — every failure, one string. Never say which factor was wrong. */
export const UNLOCK_PASSPHRASE_ERROR = 'That passphrase did not work.';

/** §6.3 pane B — same rule. Byte-identical to the change screen's wrong-current. */
export const UNLOCK_RECOVERY_ERROR = 'That recovery phrase did not work.';

/**
 * A flat, in-process-only submit disable after a failed attempt (§6.3).
 *
 * Not a lockout and not progressive: a lockout on a local vault only denies the
 * owner, and it is never persisted, so restarting the app clears it. It exists
 * to stop a held Return key from burning through attempts, nothing more.
 */
export const UNLOCK_RETRY_DELAY_MS = 1000;

/**
 * The OS keystore's user-facing name, for §6.6's help text. Read from the UA
 * because there is no command for it and getting it wrong costs nothing but a
 * slightly vaguer sentence.
 */
export function keystoreName(t) {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  if (/Mac OS X|Macintosh/i.test(ua)) return t('vault.keystoreMac', 'macOS Keychain');
  if (/Windows/i.test(ua)) return t('vault.keystoreWin', 'Windows Credential Manager');
  return t('vault.keystoreOther', 'system keyring');
}
